export default "__VITE_ASSET__C4XQ6YYJ__"